export const EventType = {
  ClickSelectSpec: "click_select_spec",
  ClickAddToCart: "click_add_to_cart",
  ClickRemoveFromCart: "click_remove_from_cart",
  ClickUpdateCart: "click_update_cart",
  ClickCheckoutForm: "click_checkout_form",
  ClickCheckoutCart: "click_checkout_cart",
  ClickDrawerCheckoutCart: "click_drawer_checkout_cart",
  ClickCheckout: "click_checkout",
  ClickProductCard: "click_product_card",
  ClickChatWithUs: "click_chat_with_us",
  ClickCategory: "click_category",
  ClickViewAll: "click_view_all",
  ClickDropHint: "click_drop_hint",
  DropHintSuccess: "drop_hint_success",
  ClickBookAppointment: "click_book_appointment",
  ClickBulgariIconImage: "click_bulgari_icon_image",
  SwipeBulgariIconImage: "swipe_bulgari_icon_image",
  ClickDiscoverMore: "click_discover_more",
  BulgariIconTabChange: "bulgari_icon_tab_change",
  OpenCartDrawer: "open_cart_drawer",
  ClickSideMenuItem: "click_side_menu_item",
  ClickLogo: "click_logo",
  ClickGoCart: "click_go_cart",
  ClickMenu: "click_menu",
  ClickDrawerBackCart: "click_drawer_back_cart",
  ClickGoBackCart: "click_go_back_cart",
  ClickTermsOfSale: "click_terms_of_sale",
  ClickGetAssistance: "click_get_assistance",
  ClickCancelOrder: "click_cancel_order",
  ClickCancelOrderKeep: "click_cancel_order_keep",
  ClickCancelOrderCancel: "click_cancel_order_cancel",
  ClickSubmitOrderForm: "click_submit_order_form",
  ClickBackToOrderForm: "click_back_to_order_form",
  ClickShareHome: "click_share_home",
  ShareHomeSuccess: "share_home_success",
  ClickBanner: "click_banner",
  ClickDeeplink: "deeplink_click",
  //common event
  AddToCart: "AddToCart",
  Purchase: "Purchase",
  //FB Event
  ViewContent: "ViewContent",
  //Line Event
  ViewItemDetail: "ViewItemDetail",
  InitiateCheckOut: "InitiateCheckOut",
};
